export default "__VITE_ASSET__CuSEr_Hv__"